import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';

class SizeSuffix extends Component {
  static propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    suffix: PropTypes.string,
    isVietnam: PropTypes.bool,
    t: PropTypes.func,
  }
  shouldComponentUpdate(nextProps) {
    if (
      (this.props.className !== nextProps.className) ||
      (parseFloat(this.props.size) !== parseFloat(nextProps.size)) ||
      (this.props.suffix !== nextProps.suffix) ||
      (this.props.isVietnam !== nextProps.isVietnam)
    ) {
      return true;
    }
    return false;
  }
  checkSizeSuffix = (suffix) => {
    const { t, isVietnam } = this.props;
    switch (suffix) {
      case 'square_metres':
        return isVietnam ? ' m²' : ` ${t('sqm', { ns: TRANSLATION_FILES.screens })}`;
      case 'square_feet':
        return ` ${t('sqft', { ns: TRANSLATION_FILES.screens })}`;
      default:
        return '';
    }
  }
  render() {
    return (
      <span className={this.props.className}>
        {
          this.props.size ?
          `${parseFloat(this.props.size)}${this.checkSizeSuffix(this.props.suffix)}`
          : '-'
        }
      </span>
    );
  }
}

export default withTranslation(namespaces)(SizeSuffix);



// WEBPACK FOOTER //
// ./src/components/SizeSuffix.jsx